export default "__VITE_ASSET__Bs0AjKXL__"